import { Button } from '@/ui'

export default function EmptyState({
  title,
  body,
  actionLabel,
  onAction,
}: {
  title?: string
  body: string
  actionLabel?: string
  onAction?: () => void
}) {
  return (
    <div className="grid place-content-center text-center px-6 py-20 h-full text-ink-500">
      {title && (
        <h2 className="font-display text-[32px] font-medium tracking-tighter m-0 mb-1.5 text-ink-1000">
          {title}
        </h2>
      )}
      <p className="m-0">{body}</p>
      {actionLabel && onAction && (
        <Button variant="primary" className="mt-4 justify-self-center" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  )
}
